
//Left menu slide down toggle 
//window.addEventListener("load", function () {

//    var dropdown = document.getElementsByClassName("dropDownBtn");
//    var i;

//    for (i = 0; i < dropdown.length; i++) {
//        dropdown[i].addEventListener("click", function () {
//            this.classList.toggle("activeDropDown");
//            var dropdownContent = this.nextElementSibling;
//            console.log("dropdownContent : " + dropdownContent.style.display);
//            if (dropdownContent.style.display === "block") {
//                dropdownContent.style.display = "none";
//            } else {
//                dropdownContent.style.display = "block";
//            }
//        });
//    }

//});

//ENQUIRY FORM
var enquirySubmitted = 0;
var mouse_is_inside = false;
var product_enquiry_title = '';
var transactionSubmitted = 0;
$(document).ready(function () {

    // -------------------------------------------------
    // Loading Spinner
    //console.log("spinning");
    var spinning = false;
    window.loadingSpinner = function (elm) {
        //$(elm).addClass('loading');

        if (!spinning) {
            $(elm).siblings('.loader').show();
            spinning = true;
        }
    }

    // -------------------------------------------------
    // AUTOCOMPLETE CLOSURE
    $('#search-predict-wrap').hover(function () { mouse_is_inside = true; }, function () { mouse_is_inside = false; });
    $('body').mouseup(function () { if (!mouse_is_inside) { $('#search-predict-wrap').hide(); } });

    // -------------------------------------------------
    //FORM VALIDATION - CONTACT US
    $('#Contact').validate({
        errorClass: 'error',
        errorPlacement: function (error, element) {
            var loc = $(element).parent();
            error.insertAfter(element);
        },
        highlight: function (element, errorClass, validClass) {
            $(element).addClass('error-box');
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('error-box');
        },
        messages: {
            Name: 'Required',
            Email: 'Required'
        },
        invalidHandler: function (form, validator) {
            var errorMsg = 'Please correct to following items:\n\n';
            $.each(validator.errorList, function (x) {
                var msg = validator.errorList[x].message + '\n';
                errorMsg += msg;
            });
        }
    });

    // -------------------------------------------------
    ////BIND EMAIL VALIDATION ON SUBMIT - CONTACT US FORM
    //$('#Contact').bind('submit', function (event) {
    //    $('#Contact input[name="Email"]').rules('add', { required: true, email: true, messages: { required: 'Required', email: 'Invalid Email'} });

    //    if (!$('#Contact').valid() || enquirySubmitted == 1) {
    //        return false;
    //    }

    //    //turn on loader
    //    enquirySubmitted = 1;
    //    $('#Contact input[type="submit"]').addClass('loading');
    //    $('#Contact .loader').show();

    //    event.preventDefault();

    //    //submit form via ajax
    //    $.ajax({
    //        type: "POST",
    //        url: $('#Contact').attr('action'),
    //        data: $('#Contact').serialize(),
    //        dataType: 'json',
    //        success: function (data) {
    //            if (data.success) {
    //                $('#Contact .form-container').hide();
    //                $('#Contact .confirmation-container').show();
    //                $('.thank-you-message', '#Contact .confirmation-container').html(data.message);
    //            }
    //            else {
    //                alert('An error occured while sending your enquiry\n\n' + data.message);
    //            }
    //        },
    //        complete: function () {
    //            enquirySubmitted = 0;
    //            $('#Contact input[type="submit"]').removeClass('loading');
    //            $('#Contact .loader').hide();
    //        }
    //    });
    //    event.preventDefault();
    //});

    //// -------------------------------------------------
    ////BIND EMAIL VALIDATION ON SUBMIT - NEWSLETTER FORM
    //$('.newsletter').bind('submit', function (event) {

    //    var newsletterForm = this;
    //    var newsletterEmail = $('input[name="Email"]', this).val();

    //    if (!isValidEmailAddress(newsletterEmail)) {
    //        alert('Email address is not valid');
    //        return false;
    //    }

    //    //turn on loader
    //    enquirySubmitted = 1;
    //    $('input[type="submit"]', newsletterForm).addClass('loading');
    //    $('.loader', newsletterForm).show();

    //    //prevent form from posting
    //    event.preventDefault();

    //    //submit form via ajax
    //    $.ajax({
    //        type: "POST",
    //        url: $(newsletterForm).attr('action'),
    //        data: $(newsletterForm).serialize(),
    //        dataType: 'json',
    //        success: function (data) {
    //            if (data.success) {
    //                $('.newsletter-confirmation', newsletterForm).show();
    //                $('.newsletter-confirmation', newsletterForm).html(data.message);
    //                $('.newsletter-form', newsletterForm).hide();
    //            }
    //            else if (data.userSubscribed) {
    //                alert(data.message);
    //                return;
    //            }
    //            else {
    //                alert('An error occured while sending your enquiry\n\n' + data.message);
    //            }
    //        },
    //        complete: function () {
    //            enquirySubmitted = 0;
    //            $('input[type="submit"]', newsletterForm).removeClass('loading');
    //            $('.loader', newsletterForm).hide();
    //        }
    //    });
    //    event.preventDefault();
    //});

    // -------------------------------------------------
    // VOUCHER BALANCE CHECK
    $('a.check-voucher-balance').click(function (e) {
        $('div.voucher-form-container').slideDown();
        $(this).hide();
        e.preventDefault();
    });

    $('.VoucherValidateForm').bind('submit', function (event) {
        addVoucherValidation(this);
        event.preventDefault();
    });

    $('a.add-voucher').click(function (event) {
        addVoucherValidation(this);
        event.preventDefault();
    });

    function addVoucherValidation(obj) {
        var currentForm = $(obj).closest('.VoucherValidateForm');

        //hide msg
        $('.promo-err', currentForm).hide();
        $('.est', currentForm).hide();

        //check if currently processing cart
        if (transactionSubmitted == 1) {
            return false;
        }

        var VoucherNo = $('input[name="VoucherNo"]', currentForm).val();
        var VoucherName = $('input[name="VoucherName"]', currentForm).val();
        if (VoucherNo == null || VoucherNo == '' || VoucherName == null || VoucherName == '') {
            $('.promo-err', currentForm).show().text('Voucher Number and Name required');
            return false;
        }

        //turn on loader
        transactionSubmitted = 1;
        $('a', currentForm).addClass('loading');
        $('.loader', currentForm).show();

        //submit form via ajax
        $.ajax({
            type: "POST",
            url: $(currentForm).attr('action'),
            data: $(currentForm).serialize(),
            dataType: 'json',
            success: function (data) {
                if (data.success) {
                    var voucherBalance = parseFloat(data.voucherBalance);
                    if (!isNaN(voucherBalance)) {
                        voucherBalance = Math.round(voucherBalance * 100) / 100;
                        $('.est', currentForm).show().html('Voucher balance is $' + voucherBalance.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,"));
                    }
                }
                else {
                    $('.promo-err', currentForm).show().text('Voucher not found');
                }
            },
            complete: function () {
                transactionSubmitted = 0;
                $('a', currentForm).removeClass('loading');
                $('.loader', currentForm).hide();
            }
        });
    }

    //$('a.add-a-voucher').click(function () {
    //    $('input[name="Name"]', '#GiftVoucherRecipient').val('');
    //    $('input[type="Submit"]', '#GiftVoucherRecipient').attr('rel-id', $(this).attr('rel-id')).attr('rel-name', $(this).attr('rel-name'));
    //});

    //$('textarea', '#GiftVoucherRecipient').bind({
    //    focus: function () { $(this).prev('label').hide(); },
    //    blur: function () { if ($(this).val() == '') { $(this).prev('label').show(); } }
    //});

    //// -------------------------------------------------
    ////FORM VALIDATION - ADD GIFT VOUCHER
    //$('#GiftVoucherRecipient').validate({
    //    errorClass: 'error',
    //    errorPlacement: function (error, element) {
    //        var loc = $(element).parent();
    //        error.insertAfter(element);
    //    },
    //    highlight: function (element, errorClass, validClass) {
    //        $(element).addClass('error-box');
    //    },
    //    unhighlight: function (element, errorClass, validClass) {
    //        $(element).removeClass('error-box');
    //    },
    //    rules: {
    //        Message: { maxlength: 500 }
    //    },
    //    messages: {
    //        Name: 'Required'
    //    },
    //    invalidHandler: function (form, validator) {
    //        var errorMsg = 'Please correct to following items:\n\n';
    //        $.each(validator.errorList, function (x) {
    //            var msg = validator.errorList[x].message + '\n';
    //            errorMsg += msg;
    //        });
    //    }
    //});

    //// -------------------------------------------------
    ////ADD GIFT VOUCHER NAME SUBMIT
    //$('#GiftVoucherRecipient').bind('submit', function (e) {

    //    $('#GiftVoucherRecipient input[name="Email"]').rules('add', { required: true, email: true, messages: { required: 'Required', email: 'Invalid Email'} });

    //    if (!$('#GiftVoucherRecipient').valid()) {
    //        return false;
    //    }

    //    //close panel
    //    $.fancybox.close();

    //    //update cart
    //    var name = $('#GiftVoucherRecipient input[name="Name"]').val();
    //    var email = $('#GiftVoucherRecipient input[name="Email"]').val();
    //    var message = $('#GiftVoucherRecipient textarea[name="Message"]').val();

    //    addGiftVoucherToCart($('input[type="submit"]', this), name, email, message);
    //    e.preventDefault();
    //});

    //// -------------------------------------------------
    ////ADD GIFT VOUCHER TO CART
    //function addGiftVoucherToCart(obj, name, email, message) {
    //    console.log('adding gift voucher to cart ')
    //    //check if currently processing cart
    //    if (addToCartSubmitted == 1) {
    //        return false;
    //    }

    //    var productName = $(obj).attr('rel-name')
    //    var productId = parseInt($(obj).attr('rel-id'));

    //    if (isNaN(productId)) {
    //        return false;
    //    }

    //    //check if quantity exceeds cart maximum
    //    var quantity = 1;
    //    if ((cartItemsCount + quantity) > cartItemsMax) {
    //        alert(cartItemsMaxMsg.replace("%%ItemQuantity%%", 1).replace("%%CartMaxItems%%", cartItemsMax));
    //        return false;
    //    }

    //    //turn on loader
    //    addToCartSubmitted = 1;

    //    //set up for attributes
    //    $('input[name="productIdUpSell"]', '#AddToCartUpSell').val(productId);
    //    $('input[name="quantityUpSell"]', '#AddToCartUpSell').val(quantity);
    //    $('input[name="priceIncrementUpSell"]', '#AddToCartUpSell').val(quantity);

    //    $('input[name="nameOnCard"]', '#AddToCartUpSell').val(name);
    //    $('input[name="emailOnCard"]', '#AddToCartUpSell').val(email);
    //    $('input[name="messageOnCard"]', '#AddToCartUpSell').val(message);

    //    //turn on loader
    //    addToCartSubmitted = 1;

    //    //submit form via ajax
    //    $.ajax({
    //        type: "POST",
    //        url: $('#AddToCartUpSell').attr('action'),
    //        data: $('#AddToCartUpSell').serialize(),
    //        dataType: 'json',
    //        success: function (data) {
    //            if (data.success) {
    //                var totalCost = parseFloat(data.totalCost);
    //                if (!isNaN(totalCost)) {
    //                    totalCost = Math.round(totalCost * 100) / 100;
    //                    $('strong[rel-type="mycart-total"]').text('$' + totalCost.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,"));
    //                }
    //                $('span[rel-type="mycart-items"]').text(data.totalItems + ' items');

    //                //update cart total items
    //                cartItemsCount = data.totalItems;

    //                //update cart items
    //                if ($.isFunction(window.updateCart)) {
    //                    updateCart();
    //                }

    //                //update cart products
    //                if ($.isFunction(window.refreshCartProducts)) {
    //                    refreshCartProducts();
    //                }

    //                //refresh pricing summary
    //                if ($.isFunction(window.refreshCartSummary)) {
    //                    refreshCartSummary();
    //                }

    //                //show pop-up if applicable
    //                if ($('span[rel-type="item-add-name"]').length > 0) {
    //                    $('span[rel-type="item-add-name"]').text(productName);
    //                    $('span[rel-type="item-add-count"]').text(quantity);
    //                    $('#added-to-cart-display').click();
    //                }
    //            }
    //            else {
    //                alert(data.message);
    //            }
    //        },
    //        complete: function () {
    //            addToCartSubmitted = 0;

    //            //clear form
    //            $('input[name="productIdUpSell"]', '#AddToCartUpSell').val(0);
    //            $('input[name="quantityUpSell"]', '#AddToCartUpSell').val(0)
    //            $('input[name="priceIncrementUpSell"]', '#AddToCartUpSell').val(0);

    //            $('input[name="nameOnCard"]', '#AddToCartUpSell').val('');
    //            $('input[name="emailOnCard"]', '#AddToCartUpSell').val('');
    //            $('textarea[name="messageOnCard"]', '#AddToCartUpSell').val('');
    //        }
    //    });
    //}

    // -------------------------------------------------
    //LOAD SHARE THIS SCRIPT
    // loadShareThisScript();

    // -------------------------------------------------
    //ASK ABOUT PRODUCT POP-UP
    $('#btn-ask-a-question').click(function () {
        var contactForm = $('#Contact');
        $('.form-container', contactForm).show();
        $('.confirmation-container', contactForm).hide();
        $('input[name="Name"]', contactForm).val('');
        $('input[name="Email"]', contactForm).val('');
        $('textarea[name="Enquiry"]', contactForm).val("I have an inquiry about '" + product_enquiry_title + "' on your website.\n\n");
    });
});

//VALIDATE EMAIL ADDRESS
function isValidEmailAddress(emailAddress) {
    var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
    return pattern.test(emailAddress);
};

//SHARETHIS SETTINGS
var switchTo5x = true;
function loadShareThisScript() {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = (document.location.protocol == 'https:') ? "https://ws.sharethis.com/button/buttons.js" : "http://w.sharethis.com/button/buttons.js";
    document.body.appendChild(script);
}

//Products Slider By Firas 

var initProductSlider = function (wrapper, innerwrapper, items, itemsClassName, items_desc, nBtn, pBtn, sideMarginPrntg, innerMarginPrntg) {
    var docWidth = $(document).width();
    var container = wrapper;
    var innerContainer = innerwrapper;
    var innerContWidth = 0;
    var pdpBlocks = items;
    var descBlocks = items_desc;
    var nextBtn = nBtn;
    var prevBtn = pBtn;

    var totBlocksWidth = 0;
    var hMax = 0; // height of the heighest block;
    var dMax = 0; // height of the heighest description block
    var bPoints; // sliding window points
    var currPrSlide = 0;

    var noItems = items.length;
    var itemsPerWindow = 2;

    if (docWidth > 480) {
        itemsPerWindow = 3;
    }

    if (docWidth > 580) {
        itemsPerWindow = 4;
    }

    var noWindows = Math.ceil(noItems / itemsPerWindow);

    if (noWindows < 2) {
        $(nBtn).hide();
        $(pBtn).hide();
    }

    //get the height of the longest descriptiong setction
    $(descBlocks).each(function (i, item) { if ($(item).height() > dMax) dMax = $(item).height(); });

    //set all description sections with the same height
    if (dMax > 0) { $(descBlocks).each(function (i, item) { $(item).height(dMax); }) }

    //calculate and set the margin ------------------------------

    var marginPerWindow, sideMargin, innerMargin;

    if (noItems > 1) {
        if (itemsPerWindow === 2) {
            marginPerWindow = docWidth - $(pdpBlocks[0]).width() * 2;

            sideMargin = marginPerWindow * sideMarginPrntg;
            innerMargin = marginPerWindow * innerMarginPrntg;

            $(itemsClassName + ':even').css({ 'margin-left': sideMargin, 'margin-right': innerMargin });
            $(itemsClassName + ':odd').css({ 'margin-left': innerMargin, 'margin-right': sideMargin });

        }
        else if (itemsPerWindow === 3) {
            marginPerWindow = docWidth - pdpBlocks[0].clientWidth * 3;
            sideMargin = marginPerWindow * 0.25;
            $(itemsClassName).css({ 'margin-left': sideMargin });
            $(itemsClassName + ':nth-of-type(4n+4)').css({ 'margin-left': sideMargin * 2 });
        }
        else if (itemsPerWindow === 4) {
            marginPerWindow = docWidth - pdpBlocks[0].clientWidth * 4;
            sideMargin = marginPerWindow * 0.20;
            $(itemsClassName).css({ 'margin-left': sideMargin });
            $(itemsClassName + ':nth-of-type(5n+5)').css({ 'margin-left': sideMargin * 2 });

        }
    }
    else {
        $(innerContainer).width(docWidth);
        $(itemsClassName).css({ 'margin': '0 auto', 'display': 'block' });
    }

    //-----------------------------------------------------------------

    // set window sliding events ------------------------------------
    innerContWidth = docWidth * noWindows;

    if (noWindows > 1) {

        bPoints = bPoints = new Array(noWindows);
        bPoints[0] = 0;
        for (var l = 1; l < noWindows; l++) {
            bPoints[l] = bPoints[l - 1] + docWidth;
        }

        $(nextBtn).click(function (e) {
            e.preventDefault;
            var nextSlid;

            if (currPrSlide + 1 > bPoints.length - 1)
                nextSlid = currPrSlide = 0;
            else
                nextSlid = currPrSlide = currPrSlide + 1;

            $(innerContainer).css({ 'left': -bPoints[nextSlid] });

        });

        $(prevBtn).click(function (e) {
            e.preventDefault;
            var nextSlid;

            if (currPrSlide - 1 < 0)
                nextSlid = currPrSlide = bPoints.length - 1;
            else
                nextSlid = currPrSlide = currPrSlide - 1;

            $(innerContainer).css({ 'left': -bPoints[nextSlid] });

        });
    }
    //--------------------------------------------------------------

    //get the hieghest element and calculate the totol width of the blocks
    $(pdpBlocks).each(function (i, item) {

        if (item.clientHeight > hMax) hMax = item.clientHeight;
        totBlocksWidth += item.clientWidth;

    });

    //set all blocks with the same hieght
    if (hMax > 0) {

        $(pdpBlocks).each(function (i, item) {
            $(item).height(hMax);
        });
        $(container).height(hMax + 6);
    }

};


